import Vue from 'vue'
import {hidePrivateDeployModule} from '@/utils/utils';

/**
 * 显示否显示该元素
 * @param el 
 * @param binding 
 * @param vnode 
 * @param oldVnode 
 * @returns 
 */
function updateDom(el:any,binding:any,vnode:any, oldVnode:any){
  let isHide    = hidePrivateDeployModule();
  if(isHide == true){
    el.style.display='none';
  }else{
    el.style.display='';
  }
};

Vue.directive('privatedeploymodulehide', {
  bind(el, binding, vnode, oldVnode) {
    updateDom(el, binding, vnode, oldVnode);
  },
  update(el, binding, vnode, oldVnode){
    updateDom(el, binding, vnode, oldVnode);
  }
})